import { MutationResult } from "@apollo/client";
import { MutationHookOptions } from "@apollo/client/react/types/types";
import { FetchResult } from "@apollo/client/link/core";
import { logout } from "../../graphql/__generated_types__/logout";
import { LOGOUT } from "../../graphql/mutation/logout";
import { useMutation } from "../use-mutation";

export type LogoutFunction = () => Promise<FetchResult<logout>>;

export function useLogout(
  options?: MutationHookOptions<logout>
): [LogoutFunction, MutationResult<logout>] {
  return useMutation<logout>(LOGOUT, options);
}
